import axios from '@/axios'

const activity = {
  async queryFirstChargeActivityDetail(params) {
    return await axios.post('/uc/firstChargeActivity/queryFirstChargeActivityDetail', params, {
      des: '直客pc判断是否允许访问活动',
      sTime: new Date().getTime(),
    })
  },
  async applyGold(params) {
    //用户中心——首充活动——立即申领交易赠金
    return await axios.post('/uc/firstChargeActivity/applyGold', params, { des: '直客pc立即申领交易赠金', sTime: new Date().getTime() })
  },
  //获取活动列表
  async getActivityList(params) {
    return await axios.post('/uc/user/activity/getActivityList', params, { des: '直客pc获取活动列表', sTime: new Date().getTime() })
  },
  //获取活动列表
  async getActivityScSetting(params) {
    return await axios.post('/uc/user/activity/getActivityScSetting', params, { des: '直客pc获取首充活动设置', sTime: new Date().getTime() })
  },
  // 获取首充活动信息
  async getFirstDepositActivity(params) {
    return await axios.post('/uc/user/activity/getFirstDepositActivity', params, { des: 'BH-pc获取首充活动信息', sTime: new Date().getTime() })
  },
  // 获取用户所有活动
  async getFindbystatusAndtime(params) {
    return await axios.post('/uc/bh/mocktrading/findbystatusAndtime', params, {
      des: '查询用户所有活动',
      sTime: new Date().getTime(),
      headers: { 'content-type': 'application/json' },
    })
  },
  // 获取活动大厅活动
  async getFindAllActivity(params) {
    return await axios.post('/common/brandLineAndImageList', params, { des: '查询活动大厅所有活动', sTime: new Date().getTime() })
  },
  // 获取用户活动详情
  async getPwuserdetial(params) {
    return await axios.post('/uc/bh/mocktrading/pwuserdetial', params, {
      des: '获取用户活动详情',
      sTime: new Date().getTime(),
      headers: { 'content-type': 'application/json' },
    })
  },
  // 重置活动
  async resetActivity(params) {
    return await axios.post('/uc/bh/mocktrading/reset', params, {
      des: '重置用户活动',
      sTime: new Date().getTime(),
      headers: { 'content-type': 'application/json' },
    })
  },
  async userLevel(params) {
    return await axios.post('/uc/bh/mocktrading/findbyaccountid', params, {
      des: '获取台湾首充活动信息',
      sTime: new Date().getTime(),
      headers: { 'content-type': 'application/json' },
    })
  },
  // 交易有奖活动
  async getTradeInfo(params) {
    return await axios.post('/uc/bh/mocktrading/tradingPrize', params, { des: '交易有奖活动', sTime: new Date().getTime() })
  },
  // 马拉松活动-活动信息
  async getMarathonActivityInfo(params) {
    return await axios.post('/uc/tradingmarathon/activityinfo', params, {
      des: '马拉松活动活动信息',
      sTime: new Date().getTime(),
      headers: { 'content-type': 'application/json' },
    })
  },
  // 马拉松活动-奖品列表
  async getMarathonPrizeinfo(params) {
    return await axios.post('/uc/tradingmarathon/prizeinfo', params, {
      des: '马拉松活动奖品列表',
      sTime: new Date().getTime(),
      headers: { 'content-type': 'application/json' },
    })
  },
  // 马拉松活动-兑换记录
  async getMarathonRecordinfo(params) {
    return await axios.post('/uc/tradingmarathon/recordinfo', params, {
      des: '马拉松活动兑换记录',
      sTime: new Date().getTime(),
      headers: { 'content-type': 'application/json' },
    })
  },
  // 马拉松活动-订单列表
  async getMarathonUserOrder(params) {
    return await axios.post('/uc/tradingmarathon/userorder', params, {
      des: '马拉松活动订单列表',
      sTime: new Date().getTime(),
      headers: { 'content-type': 'application/json' },
    })
  },
  // 马拉松活动-申请奖励
  async getMarathonApply(params) {
    return await axios.post('/uc/tradingmarathon/apply', params, {
      des: '马拉松活动申请奖励',
      sTime: new Date().getTime(),
      headers: { 'content-type': 'application/json' },
    })
  },
  // 马拉松活动-切换站点
  async switchsite(params) {
    return await axios.post('/uc/tradingmarathon/switchsite', params, {
      des: '马拉松活动切换站点',
      sTime: new Date().getTime(),
      headers: { 'content-type': 'application/json' },
    })
  },
}
export default activity



// WEBPACK FOOTER //
// ./src/api/activity.js